// @vendors
import React from 'react'
import PropTypes from 'prop-types'
// components
import { ContentBox } from 'commonsComponents/contentBox'
import OKModal from 'components/commons/OKModal/OKModal'
import OKLoadingErrorMessage from 'components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage'
// @commons
import { i18n } from 'core/i18n'

import './depositRemoveOfferModal.scss'

const { formatText } = i18n

export const DepositRemoveOfferModal = ({ onSubmit, showModal, hasCloseButton, onCloseModal, hideOfferPostState }) => {
    const { error, fetching } = hideOfferPostState

    const handleSubmit = () => {
        onSubmit();
    }

    const buildModalContent = () => {
        return (
            <ContentBox
                customClassName="deposit-remove-offer-modal"
                title={formatText('deposits-deposits_titleModalRemoveRenewalOfferPost')}
                hasShadow={false}
            >
                <OKLoadingErrorMessage isError={error} primaryTextError={formatText('deposits-deposits_errorModalRemoveRenewalOfferPost')} />
                {
                    !error &&  (
                        <div className="deposit-remove-offer-modal__wrapper">
                            <p className="deposit-remove-offer-modal__text">{formatText('deposits-deposits_descriptionModalRemoveRenewalOfferPost')}</p>
                        </div>
                    )
                }
            </ContentBox>
        );
    }

    return (
        <OKModal
            isOpen={showModal}
            content={buildModalContent()}
            contentOverflow="auto"
            footerType="navigation"
            shouldCloseOnOverlayClick={false}
            customCloseButton={!hasCloseButton}
            onSecondaryButtonClick={onCloseModal}
            onPrimaryButtonClick={handleSubmit}
            primaryButtonText="deposits-deposits_ctaModalRemoveRenewalOfferPost"
            secondaryButtonText="common-cancel"
            overlayClassName="deposit-remove-offer-modal"
            onCloseCallback={onCloseModal}
            primaryButtonLoading={fetching}
        />
    )
}

DepositRemoveOfferModal.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    hasCloseButton: PropTypes.bool,
    showModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    hideOfferPostState: PropTypes.object.isRequired
};

DepositRemoveOfferModal.defaultProps = {
    hasCloseButton: true
};

module.exports = DepositRemoveOfferModal;